{
  "concept": ["K46", "K49", "K50", "K51", "K52"],
  "placeholder": true,
  "note": "Übungsufer (Kampf-Designer mit Fabi, 25./26.10.2026): immer derselbe Kampf, vier Freunde auf Level 1 ohne Äste und Items gegen sechs Sturmwesen wie an Tag 1, feste Hindernisse, fester Startwert. Wer fällt, ist für diesen Kampf raus; keine Wunde, kein Abschied, keine XP. Sturm ruhig, Starkregen ab 60 s.",
  "name": "Übungsufer",
  "seed": 2610,
  "stormLevel": "ruhig",
  "hpFactor": 2,
  "friends": [
    { "species": "dachs", "friendClass": "dickfell", "kniff": "bau-graben-mulde", "name": "Waldemar", "x": 58, "y": 50, "mutGain": 0.4, "startMut": 0.334 },
    { "species": "igel", "friendClass": "raufbold", "kniff": "stachelball-ort", "name": "Krümel", "x": 54, "y": 33, "mutGain": 0.4, "startMut": 0.334 },
    { "species": "waschbaer", "friendClass": "beschuetzer", "kniff": "wunden-auswaschen-winken", "name": "Schalk", "x": 32, "y": 60, "mutGain": 0.4, "startMut": 0.334 },
    { "species": "eisvogel", "friendClass": "adlerauge", "kniff": "schwachstelle-ausmachen", "passive": "sturzflug-folge", "name": "Lia", "x": 28, "y": 38, "mutGain": 0.4, "startMut": 0.334 }
  ],
  "enemies": [
    { "enemy": "treibholzer", "x": 106, "y": 50, "mutGain": 1.4 },
    { "enemy": "schlammling", "x": 100, "y": 30 },
    { "enemy": "schlammling", "x": 100, "y": 70 },
    { "enemy": "schlammling", "x": 114, "y": 62 },
    { "enemy": "hagelchen", "x": 138, "y": 42, "mutGain": 0.22 },
    { "enemy": "windschnitt", "x": 130, "y": 74, "kniff": "sprung" }
  ],
  "obstacles": [
    { "id": "stein-oben", "kind": "stone", "name": "Stein", "art": "stein-klein", "x": 76, "y": 28, "radius": 4 },
    { "id": "stein-unten", "kind": "stone", "name": "Stein", "art": "stein-gross", "x": 68, "y": 72, "radius": 4.5 },
    { "id": "treibholz", "kind": "log", "name": "Treibholzstamm", "art": "treibholz-stamm", "x": 82, "y": 46, "x2": 89, "y2": 57, "radius": 2.2 },
    { "id": "gebuesch", "kind": "bush", "name": "Gebüsch", "art": "gebuesch", "x": 36, "y": 84, "radius": 8 }
  ]
}
